import { findInArray } from '@/helper'
import { activated_features } from 'customerPath/config/features'

export const hasFeature = {
  methods: {
    hasFeature(value) {
      return findInArray(activated_features, value)
    },
  },
}
